export default __webpack_public_path__ + "static/media/TVReport-documentation.0071f7f4.md";